"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    HubSpotConversations?: {
      widget: { remove: () => void; load: () => void };
    };
    hsConversationsOnReady?: Array<() => void>;
  }
}

/**
 * Removes the HubSpot live-chat launcher while mounted, so pages with their
 * own chat widget (e.g. Chatwoot on /proofrange) don't show two launchers.
 * Uses the Conversations widget API only — HubSpot analytics and forms
 * tracking keep running. The widget is restored on client-side navigation
 * away from the page.
 */
export function HideHubSpotChat() {
  useEffect(() => {
    const remove = () => window.HubSpotConversations?.widget.remove();

    if (window.HubSpotConversations) {
      remove();
    } else {
      // The HubSpot loader runs lazyOnload; queue the removal for when it's ready.
      (window.hsConversationsOnReady ??= []).push(remove);
    }

    return () => {
      window.hsConversationsOnReady = window.hsConversationsOnReady?.filter(
        (cb) => cb !== remove,
      );
      window.HubSpotConversations?.widget.load();
    };
  }, []);

  return null;
}
